<template>
  <div class="page_reportSet">
    <div class="topNav">
      <ShowNavHead />
      <div style="margin-right: 30px;">

        <button class="exportButton" v-if="activeName == 'first'" @click="addRpUser">+新增报表用户</button>
        <button v-if="(checkPermission(['reportSet_depart'],permissionLists))&&activeName == 'second'" class="exportButton" @click="AddReportSet()">+选择部门</button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs flex sb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统</el-breadcrumb-item>
          <el-breadcrumb-item>基础配置</el-breadcrumb-item>
          <el-breadcrumb-item>报表设置</el-breadcrumb-item>
          <el-breadcrumb-item>招聘效能表设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-if="checkPermission(['reportSet_tab_profit'],permissionLists)" label="利润报表设置" name="first"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['reportSet_tab_recruit'],permissionLists)" label="招聘效能表设置" name="second"></el-tab-pane>
        </el-tabs>
        <el-table :data="rpTable" style="width: 701px" v-if="activeName == 'first'" border>
          <el-table-column prop="Username" label="姓名" align="center" width="100">
          </el-table-column>
          <el-table-column prop="UserNumber" label="员工编号" align="center" width="100">
          </el-table-column>
          <el-table-column prop="Strorganname" label="部门" align="center" width="100">
          </el-table-column>
          <el-table-column prop="Strstationname" label="岗位" align="center" width="100">
          </el-table-column>
          <el-table-column prop="StrWorkState" label="在/离职" align="center" width="100">
          </el-table-column>
          <el-table-column prop="StrIspartner" label="是否合伙人" align="center" width="100">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="{row}">
              <el-button v-if="checkPermission(['reportSet_profit_dlt'],permissionLists)" type="text" size="small" @click="delRpUser(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 10px;" v-if="totalcount>0 && activeName=='first'" @current-change="currentChange" :current-page.sync="listQuery.currpage" :page-size="Number(listQuery.perpage)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        <el-table :data="tableData" style="width: 99%" v-if="activeName == 'second'">
          <el-table-column prop="Strorganname" label="部门" align="center">
          </el-table-column>
          <el-table-column label="周周期" align="center">
            <template slot-scope="scope">
              周{{ toChinese(scope.row.WeekStart)}}至周{{ toChinese(scope.row.WeekEnd) }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="月周期" align="center">
            <template slot-scope="scope">
              {{scope.row.MonthStart}}号 ~ {{scope.row.MonthEnd}}号
            </template>
          </el-table-column>
          <el-table-column prop="StartTime" label="启用时间" align="center">
            <template slot-scope="scope">
              {{scope.row.StartTime.split('T')[0]}}
            </template>
          </el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" align="center">
            <template slot-scope="scope">
              {{scope.row.CreateTime.replace('T',' ')}}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(['reportSet_edit'],permissionLists)" @click="editReportSet(scope.row)" type="text" size="small">编辑</el-button>
              <el-button v-if="checkPermission(['reportSet_recruit_dlt'],permissionLists)" type="text" size="small" @click="detReportSet(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="page_reportSet_dialog">
      <el-dialog :title="info ? '部门设置' : '新增设置'" :visible.sync="dialogVisibleSet" width="420px" :close-on-click-modal="false">
        <el-form :model="query" :rules="rules" ref="form" label-width="100px" class="demo-query">
          <el-form-item label="机构：" prop="Strorganname">
            <el-cascader v-model="Strorganname" ref="depart" :props="props" filterable :show-all-levels="false" :options="departList" @change="handleSectionChange" :disabled="query.Id!=0"></el-cascader>
          </el-form-item>
          <el-form-item label="周周期：" prop="WeekStart">
            <div class="dateSet flex">
              <el-select v-model="query.WeekStart">
                <el-option v-for="(item, index) in weekList" :key="index+'d'" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span style="width:20px;text-align: center;"> ~ </span>
              <el-select v-model="query.WeekEnd">
                <el-option v-for="(item, index) in weekList" :key="index+'d'" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="月周期：" prop="MonthStart">
            <div class="dateSet flex">
              <el-select v-model="query.MonthStart">
                <el-option v-for="(item, index) in monthList" :key="index+'d'" :label="item + '号'" :value="item">
                </el-option>
              </el-select>
              <span style="width:20px;text-align: center;"> ~ </span>
              <el-select v-model="query.MonthEnd">
                <el-option v-for="(item, index) in monthList" :key="index+'d'" :label="item + '号'" :value="item">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="启用时间：" prop="StartTime">
            <el-date-picker type="date" placeholder="选择启用时间" v-model="query.StartTime" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width:221px"></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleSet = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="删除设置 " :visible.sync="dialogVisibleDet" width="420px" :close-on-click-modal="false">
        <div>
          请确认是否删除【 {{ query.Strorganname }} 】的报表设置
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleDet = false">取 消</el-button>
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="新增报表用户 " :visible.sync="showAddRpUser" width="400px" :close-on-click-modal="false">
        <el-form :model="formData" ref="formData" label-width="60px" class="demo-query">
          <el-form-item label="用户：">
            <el-select v-model="formData.Name" value-key="Userid" placeholder="" filterable @change="val=>{changePerson(val)}">
              <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="showAddRpUser = false">取 消</el-button>
          <el-button type="primary" @click="confirmAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    parseTime
  } from '../../utils' //格式化时间格式
  export default {
    data() {
      var validatetDepart = (rule, value, callback) => {
        if (!this.query.Strorganname || !this.query.Strorgancode) {
          console.log(this.query)
          callback(new Error("请选择机构"));
        } else {
          callback();
        }
      };
      var validatetWeek = (rule, value, callback) => {
        if (!this.query.WeekStart) {
          callback(new Error("请选择周周期开始时间"));
        } else if (!this.query.WeekEnd) {
          callback(new Error("请选择周周期结束时间"));
        } else {
          callback();
        }
      };
      var validatetMon = (rule, value, callback) => {
        if (!this.query.MonthStart) {
          callback(new Error("请选择月周期开始时间"));
        } else if (!this.query.MonthEnd) {
          callback(new Error("请选择月周期结束时间"));
        } else {
          callback();
        }
      };
      return {
        tableHeight: 0,
        tableData: [],
        activeName: 'first',
        dialogVisibleSet: false,
        dialogVisibleDet: false,
        info: null,
        Strorganname: '',
        query: {
          Id: 0,
          Strorgancode: '',
          Strorganname: '',
          WeekStart: 1,
          WeekEnd: 7,
          MonthStart: 1,
          MonthEnd: 1,
          StartTime: '',
          IsDeleted: false
        },
        rules: {
          Strorganname: {
            required: true,
            validator: validatetDepart,
            trigger: "change"
          },
          WeekStart: {
            required: true,
            validator: validatetWeek,
            trigger: "change"
          },
          MonthStart: {
            required: true,
            validator: validatetMon,
            trigger: "change"
          },
          StartTime: {
            required: true,
            message: "请选择启用时间",
            trigger: "change"
          },
        },
        weekList: [{
          label: '周一',
          value: 1
        }, {
          label: '周二',
          value: 2
        }, {
          label: '周三',
          value: 3
        }, {
          label: '周四',
          value: 4
        }, {
          label: '周五',
          value: 5
        }, {
          label: '周六',
          value: 6
        }, {
          label: '周日',
          value: 7
        }],
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
        departList: [],
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        rpTable: [], //利润报表
        listQuery: {
          currpage: 1,
          perpage: 10,
          keyword: '',
          strWorkState: '',
          strstation: '',
          strorgancode: ''
        },
        userList: [], //用户列表
        showAddRpUser: false,
        formData: {
          Id: '',
          Name: '',
          Userid: '',
          IsDeleted: '',
          Remark: '',
          operation: '' // del删除  只传Id  新增 add
        },
        totalcount: 0,
        // 按钮权限参数
        butQuery:{
          path:'/reportSet',
          powerEnName:'system'
        },
        permissionLists:[]
      }
    },
    created() {
      this.calHeight();
      this.getButtonPower()
      this.getauthUserBasicReport();
      // 获取部门列表
      this.getDepartList()
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower(){
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if(res.status == 'ok'){
            let resmsg = res.msg
            if(!this.isNull(resmsg)){
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if(this.checkPermission(['reportSet_tab_profit'],this.permissionLists)){
                  this.activeName = 'first'
                }else if((!this.checkPermission(['reportSet_tab_profit'],this.permissionLists))&&(this.checkPermission(['reportSet_tab_recruit'],this.permissionLists))){
                  this.activeName = 'second'
                }
            }else{
              this.permissionLists = []
              this.activeName = ''
            }
          }else{
            this.permissionLists = []
            this.activeName = ''
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //获取效能报表信息
      getTableDate() {
        xz.getrpcyclelist().then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data
          } else {
            this.tableData = []
          }
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', '', {
          strIsDisable: ''
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children
            }
          } else {
            this.departList = []
          }
        })
      },
      //数字转汉字
      toChinese(num) {
        let digit = ['零', '一', '二', '三', '四', '五', '六', '日'];
        if (0 < num && num < 8) {
          return digit[num]
        } else {
          return false
        }
      },
      //新增设置
      AddReportSet() {
        this.info = '';
        this.query = {
          Id: 0,
          Strorgancode: '',
          Strorganname: '',
          WeekStart: 1,
          WeekEnd: 7,
          MonthStart: 1,
          MonthEnd: 1,
          StartTime: '',
          IsDeleted: false
        }
        this.$nextTick(() => {
          this.$refs[`depart`].inputValue = '';
        });

        this.dialogVisibleSet = true;
      },
      //编辑设置
      editReportSet(item) {
        this.info = item;
        this.query.Id = item.Id;
        this.query.Strorgancode = item.Strorgancode;
        this.query.Strorganname = item.Strorganname;
        this.query.WeekStart = item.WeekStart;
        this.query.WeekEnd = item.WeekEnd;
        this.query.MonthStart = item.MonthStart;
        this.query.MonthEnd = item.MonthEnd;
        this.query.StartTime = item.StartTime;
        this.query.IsDeleted = false;
        this.dialogVisibleSet = true;
        this.$nextTick(() => {
          this.$refs[`depart`].inputValue = item.Strorganname;
        });

      },
      //选择部门
      handleSectionChange() {
        this.$nextTick(() => {
          let depart = this.$refs.depart.getCheckedNodes()[0];
          this.query.Strorgancode = depart.value;
          this.query.Strorganname = depart.label;
          this.$refs.depart._data.dropDownVisible = false;
          console.log(this.query)
          this.$refs['form'].validate()
        })
      },
      submit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            xz.editrpcycle(this.query).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功')
                this.getTableDate();
              } else {
                this.$message.error('保存失败')
              }
              this.dialogVisibleSet = false;
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      detReportSet(item) {
        this.query.Id = item.Id;
        this.query.Strorgancode = item.Strorgancode;
        this.query.Strorganname = item.Strorganname;
        this.query.WeekStart = item.WeekStart;
        this.query.WeekEnd = item.WeekEnd;
        this.query.MonthStart = item.MonthStart;
        this.query.MonthEnd = item.MonthEnd;
        this.query.StartTime = item.StartTime;
        this.query.IsDeleted = true;
        this.dialogVisibleDet = true;
      },
      confirmDelete() {
        xz.editrpcycle(this.query).then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功')
            this.getTableDate();
          } else {
            this.$message.error('删除失败')
          }
          this.dialogVisibleDet = false;
        })
      },
      handleClick() {
        if (this.activeName == 'first') {
          this.getauthUserBasicReport();
        } else {
          this.getTableDate();
        }
      },
      //取利润报表用户列表
      getauthUserBasicReport() {
        xz.getauthUserBasicReport(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.rpTable = res.msg;
            this.totalcount = res.totalcount;
          } else {
            this.$message.error('系统出错')
            this.rpTable = []
          }
        })
      },
      currentChange(val) {
        this.listQuery.currpage = `${val}`;
        this.getauthUserBasicReport();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1;
        this.listQuery.perpage = val;
        this.getauthUserBasicReport();
      },
      //新增利润报表用户
      addRpUser() {
        if (this.userList.length == 0) {
          this.getauthUserInfoByorgancode();
        }
        this.formData = {
          Id: '',
          Name: '',
          Userid: '',
          IsDeleted: '',
          Remark: '',
          operation: 'add',
        };
        this.showAddRpUser = true;
      },
      //取所有用户列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000,
          keyword: '',
          strWorkState: '',
          strstation: '',
          strorgancode: '',
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == 'ok') {
            this.userList = res.msg;
          } else {
            this.$message.error('取用户列表出错')
            this.userList = [];
          }
        })
      },
      //选择用户
      changePerson(item) {
        this.formData.Userid = item.Userid;
        this.formData.Name = item.Username;
      },
      //确认新增/删除
      confirmAdd() {
        if (this.formData.operation == 'add' && !this.formData.Userid) {
          this.$message.warning('请选择用户')
        } else {
          xz.upuserBasicReport(this.formData).then(res => {
            if (res.status == 'ok') {
              this.$message.success(res.msg);
              this.getauthUserBasicReport();
            } else {
              this.$message.error(res.msg)
            }
            this.showAddRpUser = false;
          })
        }
      },
      //删除利润报表用户
      delRpUser(row) {
        this.formData = {
          Id: row.Id,
          Name: '',
          Userid: '',
          IsDeleted: '',
          Remark: '',
          operation: 'del',
        }
        this.confirmAdd()
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tabTitle {
    font-size: 18px;
    font-weight: 400;
    padding: 0 0 10px 5px;
    color: #1f2f3d;
  }

  .ftab {
    background: #fff;
    padding: 5px 10px;
  }
</style>
<style>
  .dateSet .el-input__inner {
    width: 100px;
  }
</style>